import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReconoseridServiceService} from "../../../services/reconoserid/reconoserid-service.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import Swal2 from 'sweetalert2';
import {ModalController} from "@ionic/angular";
import {Utils} from "../../../Models/Classes/utils";
import { RequestService } from 'src/app/services/request/request.service';
  import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-reconocerid',
  templateUrl: './reconocerid.component.html',
  styleUrls: ['./reconocerid.component.scss'],
})
export class ReconoceridComponent implements OnInit, OnDestroy {
  @Input() webPage:any;
  @Input() onVerificationStarted?: () => void;
  @ViewChild('verificationFrame') verificationFrame?: ElementRef<HTMLIFrameElement>;
  nombre:string = '';
  curp:string = '';
  rfc:string= '';
  @Input() correo: string = '';
  telefono:string = '';
  iframe:boolean = false;
  urlSafe;
  muestraformulario = false;
  @Input() profile: any;
  openingVerification = false;
  private completionHandled = false;
  private readonly verificationMessageHandler = (event: MessageEvent) => {
    if (event.data?.type !== 'laniakea:suma-verification-returned') {
      return;
    }

    if (!['https://laniakea.tv', 'https://www.laniakea.tv', 'https://sitio.laniakea.tv'].includes(event.origin)) {
      return;
    }

    const frameWindow = this.verificationFrame?.nativeElement.contentWindow;
    if (!frameWindow || event.source !== frameWindow) {
      return;
    }

    void this.completeVerificationReturn();
  };

    constructor(
      private reconoceridservice: ReconoseridServiceService,
      public sanitizer: DomSanitizer,
      private iab: InAppBrowser,
      private modalController: ModalController,
      private utils: Utils,
      private request: RequestService,
  ) { }

  async ngOnInit() {
    window.addEventListener('message', this.verificationMessageHandler);
    if (this.webPage) {
      this.iframe = true;
      this.open_iframe_validation(this.webPage);
    } else {
    console.log('email reconoser', this.correo);
    console.log("profile object",this.profile);

    console.log("estoy en reconocerid ngoninit", this.profile?.reconoser_url);
    /*
    if (this.profile['reconoser_url'] !== null) {
      this.reconoceridservice.getToken().then((token)=>{
        this.reconoceridservice.solicitaStatus(token,this.profile['reconoser_guid']).then((result)=>{
          // la variable es finalizado. si es false hay que mandar la url para validar con iframe
          console.log(result);
          const aprobado = (result as any)?.data?.aprobado;

          if (aprobado == true) {
            // Display success swalalert
            Swal2.fire({
              title: 'Identity verification successful, :hourglass_flowing_sand: updating your profile',
      
              icon: 'success',
              confirmButtonText: 'OK',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            });
            
            // Make a request to modify the status
            const VerificationData = {
              id: this.profile.id
              // Include the necessary data for modifying the status
            };
  
            this.request.createRequestPost('StripeIdentified', VerificationData)
              .then((response) => {
                
                const ResponseData = JSON.parse(response);
                if (ResponseData.code === 200) {
                  this.modalController.dismiss();
                  // Handle the success response if needed
                } else {
                  Swal2.fire({
                    title: 'An error occurred while updating your identity verification',
            
                    icon: 'error',
                    confirmButtonText: 'OK',
                    color: '#ffffff',
                    background: '#010f4e',
                    position: 'top-end',
                    timerProgressBar: true,
                    toast: true,
                  });
                  // Handle other response codes if needed
                }
              })
              .catch((error) => {
                // Handle the error if the request fails
                console.log(error);
              });
          }
        }).catch((error) => {
          console.log(error);
        });
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.muestraformulario = true;
    }*/
    this.muestraformulario = true;
  }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.verificationMessageHandler);
  }

  private async completeVerificationReturn(): Promise<void> {
    if (this.completionHandled) {
      return;
    }

    this.completionHandled = true;
    await this.modalController.dismiss({ verificationReturned: true }, 'verification-complete');
  }

  open_iframe_validation(url: string): void {
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  dismiss() {
    this.modalController.dismiss(this.profile);
  }
Nacionalidad;
  async change_status(): Promise<void> {
    if (this.openingVerification) {
      return;
    }

    this.openingVerification = true;
    const mobile = Capacitor.getPlatform() !== 'web';

    void Swal2.fire({
      title: 'Preparando verificación',
      text: 'Creando una sesión segura para capturar tu documento.',
      icon: 'info',
      toast: true,
      position: 'top-start',
      showConfirmButton: false,
    });

    try {
      const rawResponse = await this.request.createRequestPost('SumMexicoKYC_url', { mobile });
      const response = this.parseNestedJson(rawResponse);
      const verificationUrl = this.extractVerificationUrl(response);

      if (!verificationUrl) {
        throw new Error('SUMA did not return a valid verification URL.');
      }

      Swal2.close();
      this.iframe = true;
      this.open_iframe_validation(verificationUrl);

      try {
        this.onVerificationStarted?.();
      } catch (callbackError) {
        console.warn('The verification session opened, but status polling could not start.', callbackError);
      }
    } catch (error) {
      Swal2.close();
      console.error('Unable to open the identity verification session.', error);
      this.showError('No pudimos abrir la verificación de identidad. Inténtalo nuevamente.');
    } finally {
      this.openingVerification = false;
    }
    /*
      if(this.curp.length != 18) {
        this.showError('CURP no válida');
      }else if(this.nombre == '') {
        this.showError('Nombre erroneo');
      }else if(this.rfc.length < 12 ) {
        this.showError('RFC erroneo');
      }else if(this.telefono == '' || this.telefono.length != 10) {
        this.showError('Telefono erroneo');
      }else if(!(this.validateEmail(this.correo))) {
        this.showError('Correo no valido');
      }else {
        const reconoser_object = {
          'curp': this.curp,
          'rfc': this.rfc
        };
        this.request.createRequestPost('profile/update_reconoserid',reconoser_object).then((data) =>{
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);
            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }
          console.log(data);
          if (data.profile) {

        this.utils.loadingPresent().then(() => {
          this.reconoceridservice.getToken().then((token: string) => {
            console.log('token',token);
            this.reconoceridservice.solicitaValidacion(token, this.curp, this.correo, this.nombre, this.telefono).then((result)=>{
              console.log('result',result);
              this.iframe= true;
              this.profile['reconoser_url'] = result['data']['url'];
              this.profile['reconoser_guid'] = result['data']['procesoConvenioGuid'];
              this.open_iframe_validation(result['data']['url']);
              this.utils.loadingDismiss();
            });
          });
        }).catch((error) => {
          console.log(error);
          this.utils.loadingDismiss();
        });
                  
      }
    }).catch((error)=>{
      console.log(error);
    });
      }
    */
  }

  private parseNestedJson(value: any): any {
    let parsed = value;

    for (let attempt = 0; attempt < 4 && typeof parsed === 'string'; attempt++) {
      const candidate = parsed.trim();
      if (!candidate) {
        break;
      }

      try {
        parsed = JSON.parse(candidate);
      } catch {
        break;
      }
    }

    return parsed;
  }

  private extractVerificationUrl(value: any, depth = 0): string | null {
    if (depth > 6) {
      return null;
    }

    const parsed = this.parseNestedJson(value);
    if (typeof parsed === 'string') {
      const candidate = parsed.trim();
      return /^https?:\/\//i.test(candidate) ? candidate : null;
    }

    if (!parsed || typeof parsed !== 'object') {
      return null;
    }

    const preferredKeys = [
      'url', 'sdkUrl', 'sdk_url', 'verificationUrl', 'verification_url',
      'success', 'data',
    ];

    for (const key of preferredKeys) {
      if (Object.prototype.hasOwnProperty.call(parsed, key)) {
        const found = this.extractVerificationUrl(parsed[key], depth + 1);
        if (found) {
          return found;
        }
      }
    }

    for (const child of Object.values(parsed)) {
      const found = this.extractVerificationUrl(child, depth + 1);
      if (found) {
        return found;
      }
    }

    return null;
  }

  showError(message) {
    Swal2.fire({
      title: 'Error',
      text: message,
      icon: 'warning',
      confirmButtonText: 'Understood',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
    });
  }

}
